import { render, staticRenderFns } from "./ListShops.vue?vue&type=template&id=db839332&scoped=true"
import script from "./ListShops.vue?vue&type=script&lang=ts"
export * from "./ListShops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db839332",
  null
  
)

export default component.exports